import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/pixel';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { TestimonialsRow } from './components/TestimonialsRow';
import { PainSection } from './components/PainSection';
import { ProductPresentation } from './components/ProductPresentation';
import { BooksGrid } from './components/BooksGrid';
import { BonusesSection } from './components/BonusesSection';
import { UrgencyCountdown } from './components/UrgencyCountdown';
import { PricingSection } from './components/PricingSection';
import { UpsellComparison } from './components/UpsellComparison';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-offwhite text-dark-green font-poppins selection:bg-sage/30" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <div className="flex-grow" data-id="element-3">
          <HeroSection data-id="element-4" />
          <PainSection data-id="element-5" />
          <ProductPresentation data-id="element-6" />
          <TestimonialsRow data-id="element-7" />
          <BooksGrid data-id="element-8" />
          <BonusesSection data-id="element-9" />
          <UpsellComparison data-id="element-10" />
          <ExtendedTestimonials data-id="element-11" />
          <UrgencyCountdown data-id="element-12" />
          <PricingSection data-id="element-13" />
          <GuaranteeSection data-id="element-14" />
          <FAQSection data-id="element-15" />
          <FinalCTA data-id="element-16" />
        </div>
      </main>
      <Footer data-id="element-17" />
    </div>;
}
export { App };